import Navbar from "@/components/Navbar";
import { Card } from "@/components/ui/card";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Link, useParams } from "react-router-dom";
import { SolutionBounty } from "@/types/bounty";
const SolutionBounties = () => {
  const {
    userId
  } = useParams();

  // Shared patent bounty definition
  const sharedPatentBounty: SolutionBounty = {
    id: 999,
    title: "iSPAI Provisional Patent Approved",
    date: "2024-01-10",
    status: "Accepted",
    bountyAmount: 2500,
    isShared: true,
    collaborators: [{
      name: "Trey Fleming",
      title: "iSPAI Founder",
      profileUrl: "/trey-profile",
      amount: 2500
    }, {
      name: "Bryan Ellis",
      title: "iSPAI Chief Technology Officer",
      profileUrl: "/bryan-profile",
      amount: 2500
    }, {
      name: "Corey Vickers",
      title: "iSPAI Chief Creator",
      profileUrl: "/corey-profile",
      amount: 2500
    }, {
      name: "Miguel Escobedo",
      title: "iSPAI Chief Product Officer",
      profileUrl: "/miguel-profile",
      amount: 2500
    }, {
      name: "Yannis Kalfoglou, PhD",
      title: "iSPAI Chief Technical Advisor",
      profileUrl: "/yannis-profile",
      amount: 2500
    }]
  };

  // Bryan Ellis solution bounties
  const bryanBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Infrastructure Architecture and Roadmap",
    date: "2024-03-15",
    status: "Accepted",
    bountyAmount: 30000
  }, {
    id: 2,
    title: "iSPAI Platform MVP",
    date: "2024-02-20",
    status: "Accepted",
    bountyAmount: 25000
  }, sharedPatentBounty];

  // Chris Clayton solution bounties
  const chrisBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Product Pricing Model",
    date: "2024-03-10",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 2,
    title: "iSPAI Alliance Partner Strategy",
    date: "2024-02-25",
    status: "Accepted",
    bountyAmount: 2000
  }, {
    id: 3,
    title: "iSPAI's Business Case Framework",
    date: "2024-02-05",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 4,
    title: "iSPAI's GTM Alliance with Gryphon Citadel",
    date: "2024-01-20",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Incentives for Gryphon Citadel"
  }];

  // Trey Fleming solution bounties
  const treyBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Founding Vision and Concept",
    date: "2024-03-20",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Founder Equity"
  }, {
    id: 2,
    title: "iSPAI Initial Seed Funding Secured",
    date: "2024-02-10",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Founder Equity"
  }, {
    id: 3,
    title: "iSPAI Founding Team Assembly",
    date: "2024-01-25",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Founder Equity"
  }, sharedPatentBounty];

  // Corey Vickers solution bounties
  const coreyBounties: SolutionBounty[] = [sharedPatentBounty, {
    id: 1,
    title: "Infield Logistics Demo Knowledge Base Defined",
    date: "2024-03-12",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Cofounder Equity"
  }, {
    id: 2,
    title: "iSPAI Creation-to-Consumption Frictionless Flywheel",
    date: "2024-02-18",
    status: "Accepted",
    bountyAmount: 10000,
    isShared: true,
    collaborators: [{
      name: "Karen Watson",
      title: "iSPAI Chief Consumer",
      profileUrl: "/karen-profile",
      amount: 10000
    }]
  }, {
    id: 3,
    title: "Giblet's Ten Commandments for Creators",
    date: "2024-01-30",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Cofounder Equity"
  }];

  // Miguel Escobedo solution bounties
  const miguelBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Product Roadmap and Strategy",
    date: "2024-03-05",
    status: "Accepted",
    bountyAmount: 28000
  }, {
    id: 2,
    title: "iSPAI User Experience Framework",
    date: "2024-02-22",
    status: "Accepted",
    bountyAmount: 18000
  }, {
    id: 3,
    title: "iSPAI Feature Prioritization Model",
    date: "2024-02-01",
    status: "Accepted",
    bountyAmount: 12000
  }, sharedPatentBounty];

  // Karen Watson solution bounties
  const karenBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Consumer Experience Strategy",
    date: "2024-03-08",
    status: "Accepted",
    bountyAmount: 5000
  }, {
    id: 2,
    title: "iSPAI User Adoption Framework",
    date: "2024-02-15",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 3,
    title: "iSPAI Creation-to-Consumption Frictionless Flywheel",
    date: "2024-02-18",
    status: "Accepted",
    bountyAmount: 10000,
    isShared: true,
    collaborators: [{
      name: "Corey Vickers",
      title: "iSPAI Chief Creator",
      profileUrl: "/corey-profile",
      amount: 10000
    }]
  }, {
    id: 4,
    title: "iSPAI Call for Solutions (CfS) Fully Integrated Application",
    date: "2024-01-15",
    status: "Accepted",
    bountyAmount: 10000,
    isShared: true,
    collaborators: [{
      name: "Miguel Escobedo",
      title: "iSPAI Chief Product Officer",
      profileUrl: "/miguel-profile",
      amount: 10000
    }]
  }];

  // Yannis Kalfoglou solution bounties
  const yannisBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Knowledge Representation Architecture",
    date: "2024-03-18",
    status: "Accepted",
    bountyAmount: 40000
  }, {
    id: 2,
    title: "iSPAI AI Integration Framework",
    date: "2024-02-28",
    status: "Accepted",
    bountyAmount: 32000
  }, {
    id: 3,
    title: "iSPAI Technical Governance Model",
    date: "2024-02-08",
    status: "Accepted",
    bountyAmount: 18000
  }, sharedPatentBounty, {
    id: 4,
    title: "Decentralized Storage Solution",
    date: "2024-01-15",
    status: "Accepted",
    bountyAmount: 5000,
    isShared: true,
    collaborators: [{
      name: "Karen Watson",
      title: "iSPAI Chief Consumer",
      profileUrl: "/karen-profile",
      amount: 5000
    }]
  }];

  // Jim Lawnin solution bounties
  const jimBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Financial Strategy and Structure",
    date: "2024-03-22",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 2,
    title: "iSPAI Venture Capital Pitch Deck",
    date: "2024-02-26",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 3,
    title: "iSPAI Financial Projections Model",
    date: "2024-02-05",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 4,
    title: "iSPAI Token Economics Framework",
    date: "2024-01-18",
    status: "Accepted",
    bountyAmount: 5000,
    isShared: true,
    collaborators: [{
      name: "Shaan Ray",
      title: "iSPAI Web3 Advisor",
      profileUrl: "/shaan-profile",
      amount: 5000
    }]
  }];

  // Jess profile solution bounties
  const jessBounties: SolutionBounty[] = [{
    id: 1,
    title: "Redesign Website",
    date: "2024-03-14",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 2,
    title: "iSPAI / CURT Brand and Communication Strategy",
    date: "2024-02-24",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Retainer"
  }, {
    id: 3,
    title: "iSPAI Social Media Branding Campaign",
    date: "2024-02-03",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Retainer"
  }, {
    id: 4,
    title: "iSPAI Brand Package",
    date: "2024-01-15",
    status: "Accepted",
    bountyAmount: 3000
  }];

  // Shaan profile solution bounties
  const shaanBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Web3 Strategy",
    date: "2024-03-16",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 2,
    title: "CURT POC Blockchain Feasibility Report",
    date: "2024-02-22",
    status: "Accepted",
    bountyAmount: 5000
  }, {
    id: 3,
    title: "iSPAI Web3 Components Product",
    date: "2024-01-28",
    status: "Accepted",
    bountyAmount: 5000,
    isShared: true,
    collaborators: [{
      name: "Miguel Escobedo",
      title: "iSPAI Chief Product Officer",
      profileUrl: "/miguel-profile",
      amount: 5000
    }]
  }, {
    id: 4,
    title: "iSPAI Token Economics Framework",
    date: "2024-01-18",
    status: "Accepted",
    bountyAmount: 5000,
    isShared: true,
    collaborators: [{
      name: "Jim Lawnin",
      title: "iSPAI Financial Advisor",
      profileUrl: "/jim-profile",
      amount: 5000
    }]
  }];

  // Mike Mosher profile solution bounties
  const mikeBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Security and Privacy Position",
    date: "2024-03-12",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 2,
    title: "iSPAI Enterprise CISO FAQs",
    date: "2024-02-25",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 3,
    title: "iSPAI Platform Security Architecture Implementation Plan for AI",
    date: "2024-02-10",
    status: "Accepted",
    bountyAmount: 5000
  }, {
    id: 4,
    title: "iSPAI GRC Agentic Automation Model",
    date: "2024-01-20",
    status: "Accepted",
    bountyAmount: 5000
  }];

  // Pete profile solution bounties
  const peteBounties: SolutionBounty[] = [{
    id: 1,
    title: "Capital Project Smart Contract Playbook",
    date: "2024-03-10",
    status: "Accepted",
    bountyAmount: 20000
  }, {
    id: 2,
    title: "Owners Safety Blueprint Modernization",
    date: "2024-02-18",
    status: "Accepted",
    bountyAmount: 15000
  }, {
    id: 3,
    title: "iSPAI Academic Partnership Strategy",
    date: "2024-01-22",
    status: "Accepted",
    bountyAmount: 10000
  }];

  // Morgan Eldred solution bounties
  const morganBounties: SolutionBounty[] = [{
    id: 1,
    title: "iSPAI Information Management Framework",
    date: "2024-03-18",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, {
    id: 2,
    title: "iSPAI Member IP Protection Strategy",
    date: "2024-02-22",
    status: "In Process",
    bountyAmount: 0,
    specialValue: "100 Shares, iSPAI Common Stock, Fully Vested"
  }, {
    id: 3,
    title: "Enterprise AI Integration Roadmap for iSPAI",
    date: "2024-02-01",
    status: "Accepted",
    bountyAmount: 0,
    specialValue: "Advisor Equity"
  }, sharedPatentBounty];

  // Heather Edwards solution bounties (Chief of Staff, PBS)
  const heatherBounties: SolutionBounty[] = [{
    id: 1,
    title: "GSA Organizational Efficiency Modernization Strategy",
    date: "2024-03-25",
    status: "Accepted",
    bountyAmount: 45000
  }, {
    id: 2,
    title: "Federal Workplace Operations Excellence Framework",
    date: "2024-02-20",
    status: "Accepted",
    bountyAmount: 38000
  }, {
    id: 3,
    title: "PBS Cross-Functional Team Coordination Model",
    date: "2024-02-05",
    status: "Accepted",
    bountyAmount: 32000,
    isShared: true,
    collaborators: [{
      name: "Julia De Rosi",
      title: "Deputy Assistant Commissioner, Design and Construction",
      profileUrl: "/julia-derosi-profile",
      amount: 16000
    }]
  }, {
    id: 4,
    title: "Federal Building Portfolio Management Innovation",
    date: "2024-01-15",
    status: "Accepted",
    bountyAmount: 40000
  }, {
    id: 5,
    title: "GSA Strategic Communication and Stakeholder Engagement Protocol",
    date: "2024-01-05",
    status: "Accepted",
    bountyAmount: 28000
  }];

  // Charles Hardy solution bounties (Chief Architect, PBS)
  const charlesBounties: SolutionBounty[] = [{
    id: 1,
    title: "Federal Building Design Standards Modernization",
    date: "2024-03-22",
    status: "Accepted",
    bountyAmount: 50000
  }, {
    id: 2,
    title: "GSA Workplace Strategy Innovation Framework",
    date: "2024-02-28",
    status: "Accepted",
    bountyAmount: 42000
  }, {
    id: 3,
    title: "Federal Construction Project Delivery Excellence Model",
    date: "2024-02-10",
    status: "Accepted",
    bountyAmount: 48000,
    isShared: true,
    collaborators: [{
      name: "Julia De Rosi",
      title: "Deputy Assistant Commissioner, Design and Construction",
      profileUrl: "/julia-derosi-profile",
      amount: 24000
    }]
  }, {
    id: 4,
    title: "Real Estate Development Best Practices for Federal Properties",
    date: "2024-01-20",
    status: "Accepted",
    bountyAmount: 35000
  }, {
    id: 5,
    title: "Federal Architectural Design Innovation and Research Initiative",
    date: "2024-01-08",
    status: "Accepted",
    bountyAmount: 38000
  }];

  // Julia De Rosi solution bounties
  const juliaBounties: SolutionBounty[] = [{
    id: 1,
    title: "Federal Building Sustainable Construction Framework",
    date: "2024-03-20",
    status: "Accepted",
    bountyAmount: 35000
  }, {
    id: 2,
    title: "GSA Public Building Service Modern Workplace Strategy",
    date: "2024-02-15",
    status: "Accepted",
    bountyAmount: 25000
  }, {
    id: 3,
    title: "Federal Historic Property Adaptive Reuse Model",
    date: "2024-01-25",
    status: "Accepted",
    bountyAmount: 30000,
    isShared: true,
    collaborators: [{
      name: "Morgan Eldred, PhD",
      title: "iSPAI Information Advisor",
      profileUrl: "/morgan-profile",
      amount: 15000
    }]
  }];

  // Generic solution bounties (default)
  const genericBounties: SolutionBounty[] = [{
    id: 1,
    title: "AI Integration Strategy",
    date: "2024-02-15",
    status: "Accepted",
    bountyAmount: 25000
  }, {
    id: 2,
    title: "Knowledge Base Architecture",
    date: "2024-01-30",
    status: "Accepted",
    bountyAmount: 15000
  }, {
    id: 3,
    title: "Web3 Authentication System",
    date: "2024-01-01",
    status: "Accepted",
    bountyAmount: 10000
  }];

  // Steven Beauchemin solution bounties (Quebec-focused)
  const stevenBounties: SolutionBounty[] = [{
    id: 1,
    title: "Quebec Digital Innovation Acceleration Framework",
    date: "2024-03-20",
    status: "Accepted",
    bountyAmount: 4200
  }, {
    id: 2,
    title: "Montreal Smart City Transportation Analytics Platform",
    date: "2024-03-05",
    status: "Accepted",
    bountyAmount: 3800
  }, {
    id: 3,
    title: "Quebec Provincial AI Ethics and Governance Model",
    date: "2024-02-18",
    status: "Accepted",
    bountyAmount: 3500
  }, {
    id: 4,
    title: "French-Language AI Solutions for Quebec Public Services",
    date: "2024-02-02",
    status: "Accepted",
    bountyAmount: 4000
  }, {
    id: 5,
    title: "Quebec-Canada Innovation Partnership Strategy",
    date: "2024-01-25",
    status: "In Process",
    bountyAmount: 4500,
    isShared: true,
    collaborators: [{
      name: "Eglantine Kuntz",
      title: "Transportation Commercial Attaché",
      profileUrl: "/eglantine-profile",
      amount: 2250
    }]
  }];

  // Eglantine Pauvarel Moss solution bounties (Transportation, Maritime, and ICT Commercial Attaché)
  const eglantineBounties: SolutionBounty[] = [{
    id: 1,
    title: "Quebec-Texas Maritime Technology Partnership Framework",
    date: "2024-03-18",
    status: "Accepted",
    bountyAmount: 3800
  }, {
    id: 2,
    title: "Electric Vehicle Infrastructure Investment Strategy for US-Quebec Corridor",
    date: "2024-03-02",
    status: "Accepted",
    bountyAmount: 4200
  }, {
    id: 3,
    title: "Smart Logistics Platform for Montreal-Houston Trade Route",
    date: "2024-02-20",
    status: "Accepted",
    bountyAmount: 3500,
    isShared: true,
    collaborators: [{
      name: "Steven Jast",
      title: "Quebec Digital Innovation Strategist",
      profileUrl: "/steven-profile",
      amount: 1750
    }]
  }, {
    id: 4,
    title: "ICT Innovation Hub Model for Quebec Companies in Southern US",
    date: "2024-02-05",
    status: "Accepted",
    bountyAmount: 3200
  }, {
    id: 5,
    title: "Quebec-Canada Innovation Partnership Strategy",
    date: "2024-01-25",
    status: "In Process",
    bountyAmount: 2250,
    isShared: true,
    collaborators: [{
      name: "Steven Jast",
      title: "Quebec Digital Innovation Strategist",
      profileUrl: "/steven-profile",
      amount: 2250
    }]
  }];

  // Ozlem Tuncel Toplu solution bounties (Director of Economic Affairs, Ministry of Foreign Affairs)
  const ozlemBounties: SolutionBounty[] = [{
    id: 1,
    title: "Turkey-US Energy Sector Strategic Investment Framework",
    date: "2024-03-15",
    status: "Accepted",
    bountyAmount: 4500
  }, {
    id: 2,
    title: "Cross-Border Technology Transfer Protocol for Emerging Markets",
    date: "2024-02-28",
    status: "Accepted",
    bountyAmount: 4000
  }, {
    id: 3,
    title: "Sustainable Development PPP Model for Urban Infrastructure",
    date: "2024-02-12",
    status: "Accepted",
    bountyAmount: 3800
  }, {
    id: 4,
    title: "International Trade Facilitation Platform for MENA Region",
    date: "2024-01-30",
    status: "Accepted",
    bountyAmount: 4200,
    isShared: true,
    collaborators: [{
      name: "Eglantine Pauvarel Moss",
      title: "Transportation Commercial Attaché",
      profileUrl: "/eglantine-profile",
      amount: 2100
    }]
  }, {
    id: 5,
    title: "Economic Diplomacy Digital Transformation Initiative",
    date: "2024-01-15",
    status: "Accepted",
    bountyAmount: 3600
  }, {
    id: 6,
    title: "Foreign Investment Attraction Strategy for Clean Energy Sector",
    date: "2024-01-08",
    status: "Accepted",
    bountyAmount: 3900
  }, {
    id: 7,
    title: "Innovation Ecosystem Development Framework for Government Agencies",
    date: "2023-12-20",
    status: "Accepted",
    bountyAmount: 3300
  }];

  // Determine which bounties to display based on the userId parameter
  const getBountiesForUser = (userId: string | undefined) => {
    switch (userId) {
      case "bryan":
        return bryanBounties;
      case "chris":
        return chrisBounties;
      case "trey":
        return treyBounties;
      case "corey":
        return coreyBounties;
      case "miguel":
        return miguelBounties;
      case "karen":
        return karenBounties;
      case "yannis":
        return yannisBounties;
      case "jim":
        return jimBounties;
      case "jess":
        return jessBounties;
      case "shaan":
        return shaanBounties;
      case "mike":
        return mikeBounties;
      case "pete":
        return peteBounties;
      case "morgan":
        return morganBounties;
      case "julia":
        return juliaBounties;
      case "heather":
        return heatherBounties;
      case "charles":
        return charlesBounties;
      case "steven":
        return stevenBounties;
      case "eglantine":
        return eglantineBounties;
      case "ozlem":
        return ozlemBounties;
      default:
        return genericBounties;
    }
  };
  const solutionResponses = getBountiesForUser(userId);
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };
  const getUserName = (userId: string | undefined) => {
    switch (userId) {
      case "bryan":
        return "Bryan Ellis";
      case "chris":
        return "Chris Clayton";
      case "trey":
        return "Trey Fleming";
      case "corey":
        return "Corey Vickers";
      case "miguel":
        return "Miguel Escobedo";
      case "karen":
        return "Karen Watson";
      case "yannis":
        return "Yannis Kalfoglou, PhD";
      case "jim":
        return "Jim Lawnin";
      case "jess":
        return "Jess Simm";
      case "shaan":
        return "Shaan Ray";
      case "mike":
        return "Mike Mosher";
      case "pete":
        return "Pete Dumont";
      case "morgan":
        return "Morgan Eldred, PhD";
      case "julia":
        return "Julia De Rosi";
      case "heather":
        return "Heather Edwards";
      case "charles":
        return "Charles Hardy";
      case "steven":
        return "Steven Jast";
      case "eglantine":
        return "Eglantine Pauvarel Moss";
      case "ozlem":
        return "Ozlem Tuncel Toplu";
      default:
        return "Team Member";
    }
  };
  const getStatusBadgeClass = (status: string) => {
    switch (status) {
      case "In Process":
        return "bg-orange-50 text-orange-700";
      case "Accepted":
      default:
        return "bg-emerald-50 text-emerald-700";
    }
  };
  return <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-10 text-center">
          <h1 className="font-serif text-4xl font-bold mb-3 text-slate-800">Solution Bounties</h1>
          <h2 className="text-xl text-slate-600">
            by {getUserName(userId)}
          </h2>
        </div>
        <div className="grid gap-6">
          {solutionResponses.map(response => <Card key={response.id} className="p-6 shadow-sm hover:shadow-md transition-shadow duration-200">
              <div className="flex justify-between items-start">
                <div className="space-y-2">
                  <h3 className="font-serif text-xl font-semibold text-slate-800 bg-slate-50 px-3 py-2 rounded-md">
                    {response.title}
                  </h3>
                  <p className="text-sm text-slate-500">Captured on {response.date}</p>
                  {response.isShared && <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger className="text-sm text-blue-600 hover:text-blue-800 mt-2 inline-flex items-center">
                          
                        </TooltipTrigger>
                        <TooltipContent className="p-4 max-w-sm bg-white shadow-lg rounded-lg border">
                          <h4 className="font-semibold mb-2 text-slate-800">Also awarded to:</h4>
                          {response.collaborators?.map((collaborator, index) => <div key={index} className="mb-2 border-b border-slate-100 pb-2 last:border-0">
                              <Link to={collaborator.profileUrl} className="text-blue-600 hover:text-blue-800 font-medium">
                                {collaborator.name}
                              </Link>
                              <p className="text-sm text-slate-500">{collaborator.title}</p>
                              <p className="text-sm font-medium text-slate-700">{formatCurrency(collaborator.amount)}</p>
                            </div>)}
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>}
                </div>
                <div className="text-right">
                  <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${getStatusBadgeClass(response.status)}`}>
                    {response.status}
                  </span>
                  {response.specialValue ? <p className="mt-2 font-semibold text-slate-800">{response.specialValue}</p> : <p className="mt-2 font-semibold text-slate-800">{formatCurrency(response.bountyAmount)}</p>}
                </div>
              </div>
            </Card>)}
        </div>
      </main>
    </div>;
};
export default SolutionBounties;